import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setError } from './../../actions';
import { setUserById } from './../../actions/setUserById';
import { getError } from './../../reducers';
import { auth } from './../../config/Fire';
import LogIn from './../../components/LogIn';
import LoadingPage from './../../components/LoadingPage';
import { message } from 'antd';

class LogInContainer extends Component {
    constructor() {
        super();
        this.state = {
            loading: true,
        };
    }

    login = ({ email, password }) => {
        this.setState({ loading: true });
        auth.signInWithEmailAndPassword(email, password)
        .then(()=>{
            
        })
        .catch((error) => {
            this.setState({ loading: false });
            if(error.code && (error.code === "auth/wrong-password" || error.code === "auth/user-not-found")) {
                message.error("La contrseña es incorrecta o el usuario no existe");
            } else {
                if(error.code && error.code === "auth/invalid-email") {
                    message.error("Email incorrecto");
                } else {
                    if(error.code && error.code === "auth/too-many-requests") {
                        message.error("Se realizaron demasiados intentos. Por favor, intente mas tarde o contactese con soporte.");
                        //ENVIAR ADVERTENCIA SOBRE INTENTOS PARA EMAIL INGRESADO
                    } else {
                        console.log(error);
                    }
                }
            }
        });
    };

    authListener() {
        auth.onAuthStateChanged((user) => {
            if(user && user.uid) {
                this.setState({ loading: true });
                const { setUserById } = this.props;
                setUserById(user.uid);
            } else {
                this.setState({ loading: false });
            }
        });
    }

    componentDidMount() {
        this.authListener();
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.error.state) {
            auth.signOut();
            this.props.setError({ state: false, reason: ""});
            this.setState({ loading: false });
        } else {
            
        }
    }

    render() {
        return (
            <div>
                {
                    this.state.loading ?
                        <LoadingPage />
                        :
                        <LogIn onLogIn={this.login} />
                }
            </div>
        );
    }
}

LogInContainer.propTypes = {
    setUserById: PropTypes.func.isRequired,
    setError: PropTypes.func.isRequired,
    error: PropTypes.object,
};

const mapDispatchToPropsActions = dispatch => ({
    setUserById: value => dispatch(setUserById(value)),
    setError: value => dispatch(setError(value)),
});

const mapStateToProps = state => ({ 
    error:  getError(state),
});
  
export default connect(mapStateToProps, mapDispatchToPropsActions)(LogInContainer);